import { render } from "./priceArea.vue?vue&type=template&id=43a4be29&scoped=true"
import script from "./priceArea.vue?vue&type=script&lang=js"
export * from "./priceArea.vue?vue&type=script&lang=js"

import "./priceArea.vue?vue&type=style&index=0&id=43a4be29&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a4be29"]])

export default __exports__